module.exports = __webpack_public_path__ + "static/media/phisherman-head.392e8f2e.svg";